import { MessageRetailerOrBrandButton, NEED_MORE_INFO, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
export var ItemDelayedIA = function ItemDelayedIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return NEED_MORE_INFO(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [SORRY_FOR_YOUR_ISSUES(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var SORRY_FOR_YOUR_ISSUES = function SORRY_FOR_YOUR_ISSUES(strictLocalize) {
  return strictLocalize({
    id: "mGlhMH",
    defaultMessage: "We’re sorry to hear that you’re having issues with your order. Please message the brand or contact us if you need more help."
  });
};